<template>
  <div v-if="showPermits">
    <PermitsSidebar v-if="$route.name !== 'user-with-permit' && $route.name !== 'add-user-with-permit'" :selectedTenant="selectedTenant" />
    <AddEditPermitView v-if="$route.name === 'user-with-permit' || $route.name === 'add-user-with-permit'" :selectedTenant="selectedTenant" ref="permit"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddEditPermitView from './AddEditPermitView';
import PermitsSidebar from './PermitsSidebar';

export default {
  components: {
    PermitsSidebar,
    AddEditPermitView,
  },
  props: [
    'selectedTenant',
  ],
  data() {
    return {
      showPermits: false,
    };
  },
  computed: mapGetters({
    user: 'user/user/user',
    permits: 'landlord/permits/permits',
    products: 'landlord/products/products',
  }),
  created() {
    this.fetchAllData();
  },
  watch: {
    $route: 'fetchAllData',
  },
  methods: {
    fetchAllData() {
      this.fetchPermits();
      this.fetchProducts();
    },
    fetchPermits() {
      if (this.user.data) {
        this.$store.dispatch('landlord/permits/fetchUserPermits', { user: this.user, limit: 2000, userId: this.$route.params.id }).then(() => {
          if (this.permits && this.permits.items && this.permits.items.length > 0) {
            this.permits.items.sort((a, b) => this.dynamicSort('id', a, b)).filter(() => true);
          }
        });
      }
    },
    fetchProducts() {
      if (this.isTenant() && this.user.data) {
        this.$store.dispatch('landlord/products/fetchPermitProducts', { user: this.user }).then(() => {
          if (this.products.data.length > 0) {
            this.showPermits = true;
          } else {
            this.showPermits = false;
          }
        });
      } else {
        this.showPermits = true;
      }
    },
    dynamicSort(property, a, b) {
      if (a[property] < b[property]) {
        return -1;
      } else if (a[property] > b[property]) {
        return 1;
      }
      return 0;
    },
  },
};
</script>
<style scoped lang="scss">
.end-user {
  display: flex;

  @media screen and (max-width: 760px) {
    flex-direction: column;
  }

  > div:first-child {

    @media screen and (max-width: 760px) {
      width: 100%;
    }

  }

  /*@media screen and (max-width: 1074px) { /* 1024px */
   /*flex-direction: column;

   .user-details-container {
     margin: 0;
   }*/
  /*}*/
}
</style>



// WEBPACK FOOTER //
// src/components/users/Permits.vue